import React, { FC } from 'react'
import { type FeedData } from 'pages/native/userFeed/types'
import DefaultShield from 'assets/images/shield_2_256x256.png'

import classes from './TeamInfo.module.scss'

type TeamInfoProps = {
  team?: FeedData['awayTeam'] | FeedData['homeTeam']
}

export const TeamInfo: FC<TeamInfoProps> = ({ team }) => {
  if (!team) {
    return <span>no team</span>
  }
  return (
    <div className={classes.Container}>
      <img
        className={classes.Logo}
        src={team.badge_url || DefaultShield}
        alt={team.name}
      />
      <span className={classes.Title}>{team.name}</span>
    </div>
  )
}
